import type { SVGProps } from 'react';

export const DataLayersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="icon/maps/layers_24px"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16L19.36 10.27L21 9L12 2L3 9L4.63 10.27L12 16ZM11.99 18.54L4.62 12.81L3 14.07L12 21.07L21 14.07L19.37 12.8L11.99 18.54ZM17.7398 9.00125L11.9998 4.53125L6.25977 9.00125L11.9998 13.4712L17.7398 9.00125Z"
      fill={props.fill ?? 'white'}
    />
  </svg>
);

export default DataLayersIcon;
